import React, { useState } from "react";
import Swal from "sweetalert2";
import { FaUser, FaEnvelope, FaServicestack, FaPen, FaDollarSign, FaListOl } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    package: "",
    budget: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("https://formspree.io/f/xdklredg", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    }).then((res) => {
      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Submitted!",
          text: "Thank you for your query. I will contact you soon.",
          confirmButtonColor: "#ff4e50",
        });
        setFormData({ name: "", email: "", package: "", budget: "", message: "" });
      }
    });
  };

  return (
    <section id="contact" className="py-5" style={{ background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)" }}>
      <div className="container">
        <div className="text-center mb-5 text-white">
          <h2 className="fw-bold">Contact Me</h2>
          <p className="text-light">
            Select a package (or choose custom), tell your budget and share your requirements 🚀
          </p>
          <div
            className="mx-auto mt-2"
            style={{
              width: "80px",
              height: "3px",
              background: "linear-gradient(135deg, #ff4e50, #f9d423)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-8">
            <form
              onSubmit={handleSubmit}
              className="p-5 rounded-4"
              style={{
                background: "#162447",
                boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              }}
            >
              {/* Name */}
              <div className="mb-3">
                <label className="form-label text-white d-flex align-items-center">
                  <FaUser className="me-2" /> Name
                </label>
                <input
                  type="text"
                  className="form-control bg-dark text-white border-0"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                />
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label text-white d-flex align-items-center">
                  <FaEnvelope className="me-2" /> Email
                </label>
                <input
                  type="email"
                  className="form-control bg-dark text-white border-0"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                />
              </div>

              {/* Package Selection */}
              <div className="mb-3">
                <label className="form-label text-white d-flex align-items-center">
                  <FaListOl className="me-2" /> Select Package
                </label>
                <select
                  className="form-select bg-dark text-white border-0"
                  name="package"
                  value={formData.package}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Choose a Package --</option>


  {/* Custom Website */}
  <option value="#1 - Basic Custom Website">#1 - Basic ($80) - 2-page Custom Website</option>
  <option value="#2 - Standard Custom Website">#2 - Standard ($160) - 5-page Custom Website</option>
  <option value="#3 - Advanced Custom Website">#3 - Advanced ($250) - 8-page Custom Website</option>

  {/* WordPress Website */}
  <option value="#4 - Basic WordPress Website">#4 - Basic ($60) - 2-3 Page WordPress Site</option>
  <option value="#5 - Standard WordPress Website">#5 - Standard ($140) - 5-page WordPress Site</option>
  <option value="#6 - Advanced WordPress Website">#6 - Advanced ($220) - 8-page WordPress Site</option>

  {/* E-Commerce Website */}
  <option value="#7 - Basic E-Commerce Website">#7 - Basic ($350) - Up to 10 Products</option>
  <option value="#8 - Standard E-Commerce Website">#8 - Standard ($450) - Up to 25 Products</option>
  <option value="#9 - Advanced E-Commerce Website">#9 - Advanced ($600) - Up to 50 Products</option>

  {/* SEO Custom Website */}
  <option value="#10 - Basic SEO Custom Website">#10 - Basic ($80) - SEO for 5 Pages</option>
  <option value="#11 - Standard SEO Custom Website">#11 - Standard ($160) - SEO for 10 Pages</option>
  <option value="#12 - Advanced SEO Custom Website">#12 - Advanced ($300) - SEO for 20 Pages</option>

  {/* SEO WordPress Website */}
  <option value="#13 - Basic SEO WordPress Website">#13 - Basic ($80) - SEO for 5 Pages</option>
  <option value="#14 - Standard SEO WordPress Website">#14 - Standard ($160) - SEO for 10 Pages</option>
  <option value="#15 - Advanced SEO WordPress Website">#15 - Advanced ($320) - SEO for 20 Pages</option>

  {/* Logo Design */}
  <option value="#16 - Basic Logo Design">#16 - Basic ($50) - Minimal Logo Design</option>
  <option value="#17 - Standard Logo Design">#17 - Standard ($80) - 2-3 Initial Concepts</option>
  <option value="#18 - Advanced Logo Design">#18 - Advanced ($150) - 4-5 Initial Concepts</option>

  {/* Paid Ads Setup */}
  <option value="#19 - Basic Paid Ads Setup">#19 - Basic ($60+) - Facebook, Instagram & Google Ads Setup</option>
  <option value="#20 - Standard Paid Ads Setup">#20 - Standard ($120+) - Full Ads Management</option>
  <option value="#21 - Advanced Paid Ads Setup">#21 - Advanced ($200+) - Full Ads Management with Targeting</option>
                  <option value="None - Custom Requirements">None of these (Custom Requirements)</option>
                </select>
              </div>

              {/* Budget */}
              <div className="mb-3">
                <label className="form-label text-white d-flex align-items-center">
                  <FaDollarSign className="me-2" /> Your Budget (USD)
                </label>
                <input
                  type="number"
                  className="form-control bg-dark text-white border-0"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  placeholder="Enter your estimated budget"
                />
              </div>

              {/* Message */}
              <div className="mb-3">
                <label className="form-label text-white d-flex align-items-center">
                  <FaPen className="me-2" /> Your Query
                </label>
                <textarea
                  className="form-control bg-dark text-white border-0"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Write your query here..."
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn w-100 fw-bold"
                style={{
                  background: "linear-gradient(135deg, #ff4e50, #f9d423)",
                  color: "#fff",
                  transition: "0.3s",
                }}
              >
                Send Query
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
